import {autoserializeAs, inheritSerialization} from 'cerialize';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class RsvpQuestionOption extends ModelBase {
  public static readonly type = 'RsvpQuestionOption';
  public readonly type = RsvpQuestionOption.type;

  @autoserializeAs('id')
  public id: number;

  @autoserializeAs('rsvp_question_id')
  public rsvpQuestionId: number;

  @autoserializeAs('text')
  public text: string;
}
